module.exports = __webpack_public_path__ + "img/checked.d895468c.svg";